<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import DataService from '../../../services/dataService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required} from 'vuelidate/lib/validators'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          ref_pessoa: '',
          pessoa: {
            nome: ''
          }
        },
        dependencies: {},
        selectedRoles: []
      }
    },
    validations: {
      form: {
        ref_pessoa: {required}
      }
    },
    mounted () {
      this.getDependencies()
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('user', null, id, null, ['roles'])
          .then(response => {
            this.form = response
            this.selectedRoles = response.roles.map((item) => {
              return item.id
            })
            this.isLoadingData = false
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
          })
      } else {
        this.isLoadingData = false
      }
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'role'}]).then((result) => {
          this.dependencies = result
        })
      },
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        data.roles = this.selectedRoles
        restfulService.save('user', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'user.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Usuários"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados do Usuário</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     v-on:submit.prevent="onSend">
                <el-form-item label="Matrícula"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.ref_pessoa.$error }">
                    <el-input v-model="form.ref_pessoa"
                              @input="$v.form.ref_pessoa.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.ref_pessoa.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="Nome">
                    <el-input v-model="form.pessoa.nome" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="Perfis do Usuário">
                    <el-transfer
                            v-model="selectedRoles"
                            :data="dependencies.roles"
                            :titles="['Disponíveis', 'Selecionados']"
                            :props="{
                                      key: 'id',
                                      label: 'name'
                                    }">
                    </el-transfer>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="user.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?443377db